import { useEffect, useState } from "react";
import { Sparkle } from "@phosphor-icons/react";
import api from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

/** Dashboard card: the latest Claude-written daily manager brief (cron-generated). */
export function DailyBrief() {
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    api.get("/assistant/summary/latest").then((r) => setSummary(r.data?.text ? r.data : null)).catch(() => {});
  }, []);
  if (!summary) return null;
  return (
    <Card className="border-border shadow-none" data-testid="daily-brief-card">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Sparkle size={18} className="text-primary" /> Daily brief
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground mb-1" data-testid="daily-brief-date">{summary.date} · {summary.venue_name}</p>
        <p className="text-sm whitespace-pre-wrap" data-testid="daily-brief-text">{summary.text}</p>
      </CardContent>
    </Card>
  );
}
